import { create } from "zustand";

type AlertDialogState = {
  open: boolean;
  title: string;
  message: string;
  showAlert: (message: string, title?: string) => void;
  closeAlert: () => void;
};

export const useAlertDialogStore = create<AlertDialogState>((set) => ({
  open: false,
  title: "",
  message: "",
  showAlert: (message, title = "Unable to continue") =>
    set({ open: true, message, title }),
  closeAlert: () => set({ open: false }),
}));
